export class budgetBO {
  id: string = "00000000-0000-0000-0000-000000000000"
  clientId: string = "00000000-0000-0000-0000-000000000000"
  edit: boolean = false;
  isDisable: boolean = false;
}

export class GetClientEvaluation {
  orderColumn: string = "ClientName";
  orderType: string = "asc";
  pageitem: number = 10;
  clientId: string;
  ages: number | null;
  client: string;
  currentpageno: number = 1;
  field: string = "ClientName";
  value: string = "";
  matchCase: boolean = false;
  type: string = "string";
  operator: string = "startswith";
  employeeID: string | null;
  relationshipFilter: string | null;
  agency: string | null;
  state: string;
  onboardId: string | null;
  importdate: string;
  status: string;
}

export class columnWidth {
  column: string = "";
  width: number = 0;
}

export class filter {
  clientId: string = "00000000-0000-0000-0000-000000000000"
  importdate: string;
}

export class BasicAdvance {
  isbasicview: boolean;

}

export class BudgetLogBO {
  budgetId: string;
  loginUsername: string;
  createdDateTime: string;
  attribute_AffectedColumns: string;
  oldValue: string;
  newValue: string;
}